/**
 * 방화벽 정책 store
 * Ipv4, Ipv6
 * @since 2018-11-12
 * @author devp026
 */
import { CmApiPrefix as poApiPrefix, SecutiryPolicyApiPrefix as spApiPrefix, ObjectSecProfileApiPrefix as opApiPrefix, CommonApiPrefix as cmnApiPrefix } from 'utils'
import {pcDownloadFile} from '~/utils/files'
import { sleep } from '~/utils/common'
import {
  pickAppData, updateRuleSeq, initFwRulesAddressData, initFwRulesServiceData, initFwRulesApplicationData, initSecurityProfileData,
  initFwV4RulesData, resFwRulesList, initFwV6RulesData, initClosedFwGroups, getDefaultState, parseBatchValue, binarySearch
} from '~/utils/policyUtils'
export const state = () => getDefaultState()
export const mutations = {
  releaseAllState (state) {
    const version = state.version, defaultState = getDefaultState(version)
    _.forEach(defaultState, (v, k) => { state[k] = v })
  },
  setFilterValue (state, data) { state.filterType = data },
  seletedTreeInfo (state, data) { state.treeInfo = data },
  setSelectCell (state, data) { state.isSelectCell = data }, // 객체뷰 - 선택된 정책이 있는지 설정
  setIpVersion (state, version) { // 방화벽 IP Version 설정
    state.version = version
    state.fwRulesData = version === 4 ? initFwV4RulesData() : initFwV6RulesData()
  },
  setContextInTimeObjectData (state, data) { state.fwRuleTimeData = data }, // 방화벽 정책 context-menu 시간 객체 자동 생성에서 선택한 시간 객체 추가
  setSelectGroupList (state, data) { // 그룹 리스트
    state.selectGroupList = Object.freeze(data)
    data = Object.freeze(data)
  },
  setFwEachRule (state, data) { // 방화벽 정책 데이터
    state.fwEachRuleStore = Object.freeze(data)
    data = Object.freeze(data)
  },
  getFwRulesList (state, data) { // 방화벽 정책 목록 조회
    state.fwRulesList = Object.freeze(data)
    data = Object.freeze(data)
  },
  addFwObjectData (state, {item, objectType}) { // 정책 팝업 창에서 객체 별 추가
    if (_.get(item, ['length']) > 0) {
      const totalParam = []
      for (let i = 0; i < item.length; i++) {
        let name = null
        if (_.some(['srv', 'srv_obj'], (item) => item === objectType)) {
          name = item[i].srv_obj_uname
        } else if (_.some(['src', 'dst', 'src_addr_obj', 'dst_addr_obj'], (item) => item === objectType)) {
          name = item[i].addr_obj_uname
        } else if (_.some(['app', 'app_obj'], (item) => item === objectType)) {
          name = item[i].app_obj_name
        }
        item[i].name = name
        totalParam.push(item[i])
      }
      if (_.some(['srv', 'srv_obj'], (item) => item === objectType)) {
        state.fwRulesData.fw_rule[0].srv_obj = []
        state.fwRulesData.fw_rule[0].srv_obj = totalParam
      } else if (_.some(['src', 'src_addr_obj'], (item) => item === objectType)) {
        state.fwRulesData.fw_rule[0].src_addr_obj = []
        state.fwRulesData.fw_rule[0].src_addr_obj = totalParam
      } else if (_.some(['dst', 'dst_addr_obj'], (item) => item === objectType)) {
        state.fwRulesData.fw_rule[0].dst_addr_obj = []
        state.fwRulesData.fw_rule[0].dst_addr_obj = totalParam
      } else if (_.some(['app', 'app_obj'], (item) => item === objectType)) {
        state.fwRulesData.fw_rule[0].app_obj = []
        state.fwRulesData.fw_rule[0].app_obj = totalParam
      }
    } else {
      if (_.some(['srv', 'srv_obj'], (item) => item === objectType)) {
        state.fwRulesData.fw_rule[0].srv_obj = initFwRulesServiceData()
      } else if (_.some(['src', 'src_addr_obj'], (item) => item === objectType)) {
        state.fwRulesData.fw_rule[0].src_addr_obj = initFwRulesAddressData()
      } else if (_.some(['dst', 'dst_addr_obj'], (item) => item === objectType)) {
        state.fwRulesData.fw_rule[0].dst_addr_obj = initFwRulesAddressData()
      } else if (_.some(['app', 'app_obj'], (item) => item === objectType)) {
        state.fwRulesData.fw_rule[0].app_obj = initFwRulesApplicationData()
      }
    }
    state.selectedAddObjectData = void 0
  },
  addFwObjectViewData (state, {result}) { // 오브젝트 뷰에서 객체 별 추가
    state.fwRulesList = Object.freeze(_.map(state.fwRulesList, (o) => {
      if (o.fw_rule_id === result.fw_rule_id) o = result
      return o
    }))
  },
  addFwMultipleObjectViewData (state, {result}) { // 오브젝트 뷰에서 객체 별 일괄 추가
    state.fwRulesList = Object.freeze(_.map(state.fwRulesList, (o) => {
      if (o.fw_rule_id === result.fw_rule_id) o = result
      return o
    }))
  },
  searchSelectFwPolicyRules (state, data) { state.searchSelectedPolicyData = data }, // 방화벽 검색 결과 정책 선택
  resetSearchSelectFwPolicyRules (state) { state.searchSelectedPolicyData = void 0 }, // 방화벽 검색 결과 정책 선택 초기화
  resetFwRulesData (state) { // 방화벽 정책 store 초기화
    const version = Number(state.version)
    state.fwRulesData = version === 4 ? initFwV4RulesData() : initFwV6RulesData()
  },
  selectedAddObject (state, data) { state.selectedAddObjectData = data }, // 추가된 객체 선택
  selectedPolicyRules (state, data) { // 방화벽 정책 선택
    state.selectedPolicyData = data
    state.copyFwRulesData = _.map(state.copyFwRulesData, (o) => { return _.assign(o, { fw_grp_id: data.fw_grp_id, pre_rule_id: data.fw_rule_id, up_down: 1 }) })
  },
  resetFwRuleTimeData (state) { // 방화벽 정책 - 시간 객체 데이터 초기화
    state.fwRuleTimeData = void 0
    state.fwRulesData.time = 0
    if (state.fwRulesData.fw_rule[0].time_obj_id) state.fwRulesData.fw_rule[0].time_obj_id = 0
  },
  resetSelectedPolicyRules (state) { // 방화벽 정책 선택 초기화, 복사된 정책 데이터 초기화
    state.selectedPolicyData = void 0
    state.isSelectCell = false
  },
  setFirewallTimeObjectData (state, data) { // time_obj_row, 방화벽 정책 시간 객체 추가
    let timeObj = 0
    if (data.time_obj === undefined) {
      if (typeof data.time_obj_set === 'string') data.time_obj_set = JSON.parse(data.time_obj_set)
      state.fwRuleTimeData = data
    } else {
      if (data.time_obj.time_obj_id !== undefined) state.fwRuleTimeData = data.time_obj
      else state.fwRuleTimeData = void 0
    }
    timeObj = data.time_obj_id
    if (timeObj === null) timeObj = 0
    state.fwRulesData.fw_rule[0].time_obj_id = timeObj
  },
  updateFwRules (state, data) { // 방화벽 정책 수정
    state.fwRulesList = Object.freeze(_.map(state.fwRulesList, (o) => {
      if (o.fw_rule_id === data.fw_rule_id) o = data
      return o
    }))
  },
  getFwRules (state, data) { // 방화벽 정책 조회
    if (!data) return
    const result = {}
    if (data.src_addr_obj.length === 0) {
      data = _.assign(data, { src_addr_obj: initFwRulesAddressData() })
    } else {
      for (let i = 0; i < data.src_addr_obj.length; i++) {
        data.src_addr_obj[i].name = data.src_addr_obj[i].addr_obj_uname
      }
    }
    if (data.dst_addr_obj.length === 0) {
      data = _.assign(data, { dst_addr_obj: initFwRulesAddressData() })
    } else {
      for (let i = 0; i < data.dst_addr_obj.length; i++) {
        data.dst_addr_obj[i].name = data.dst_addr_obj[i].addr_obj_uname
      }
    }
    if (data.srv_obj.length === 0) {
      data = _.assign(data, { srv_obj: initFwRulesServiceData() })
    } else {
      for (let i = 0; i < data.srv_obj.length; i++) {
        data.srv_obj[i].name = data.srv_obj[i].srv_obj_uname
      }
    }
    if (_.get(data, ['app_obj', 'length'], 0) === 0) {
      data = _.assign(data, { app_obj: initFwRulesApplicationData() })
    } else {
      data = _.assign(data, {
        app_obj: _.map(data.app_obj, item => _.assign(item, {
          name: item.app_type === 3 ? item.app_filter_obj_uname : item.app_obj_name,
          app_obj_id: item.app_type === 3 ? item.app_filter_obj_id : item.app_obj_id
        }))
      })
    }
    if (typeof data.security_profile === 'object') { // 프로파일 설정
      const securityProfile = {}
      const idDict = {
        ips_prf: 'ips_prf_id',
        av_prf: 'av_prf_id',
        as_prf: 'as_prf_id',
        wf_prf: 'wf_prf_id',
        dlp_prf: 'dlp_prf_id',
        file_type_ctrl_prf: 'file_type_ctrl_prf_id',
        apt_prf: 'apt_prf_id'
      }
      _.forEach(_.keys(data.security_profile), profile => {
        const id = _.get(idDict, profile, 'id')
        securityProfile[profile] = _.get(data.security_profile, [profile, id])
      })
      data.security_profile = securityProfile
    } else data.security_profile = initSecurityProfileData()
    result.device_id = Number(data.device_id)
    result.fw_grp_id = Number(data.fw_grp_id)
    result.fw_rule = [data]
    result.fw_rule_ext_header_set = data.fw_rule_ext_header_set
    if (Number(state.version) === 6) {
      result.fw_rule_ext_header_set = {}
      if (data.fw_rule_ext_header_set.hop !== undefined) {
        result.fw_rule_ext_header_set.hop = data.fw_rule_ext_header_set.hop
      } else result.fw_rule_ext_header_set.hop = 0
      if (data.fw_rule_ext_header_set.routing !== undefined) {
        result.fw_rule_ext_header_set.routing = data.fw_rule_ext_header_set.routing
      } else result.fw_rule_ext_header_set.routing = 0
      if (data.fw_rule_ext_header_set.fragment !== undefined) {
        result.fw_rule_ext_header_set.fragment = data.fw_rule_ext_header_set.fragment
      } else result.fw_rule_ext_header_set.fragment = 0
      if (data.fw_rule_ext_header_set.dest !== undefined) {
        result.fw_rule_ext_header_set.dest = data.fw_rule_ext_header_set.dest
      } else result.fw_rule_ext_header_set.dest = 0
      if (data.fw_rule_ext_header_set.auth !== undefined) {
        result.fw_rule_ext_header_set.auth = data.fw_rule_ext_header_set.auth
      } else result.fw_rule_ext_header_set.auth = 0
      if (data.fw_rule_ext_header_set.esp !== undefined) {
        result.fw_rule_ext_header_set.esp = data.fw_rule_ext_header_set.esp
      } else result.fw_rule_ext_header_set.esp = 0
    }
    state.fwRulesData = result
    data = Object.freeze(data)
  },
  deleteBatchFwRules (state, data) { // 방화벽 정책 일괄 삭제
    let fwRulesList = _.cloneDeep(state.fwRulesList)
    _.forEach(data, (o) => {
      const itemIndex = _.findIndex(fwRulesList, {fw_rule_id: o.fw_rule_id})
      fwRulesList.splice(itemIndex, 1)
    })
    state.fwRulesList = Object.freeze(fwRulesList)
    data = Object.freeze(data)
    fwRulesList = null
    updateRuleSeq(state) // 정책 seq 업데이트
  },
  fwSetGroupBatch (state, {type, batchValue, groupId}) { // 방화벽 정책 그룹 일괄 설정
    if (type === 'all') {
      state.fwRulesList = Object.freeze(_.map(state.fwRulesList, (rules) => {
        if (!rules.is_group && rules.fw_grp_id === groupId) rules = parseBatchValue(rules, batchValue)
        return rules
      }))
    } else if (type === 'editSearch' || type === 'applySearch') {
      const fwRulesList = _.cloneDeep(state.fwRulesList)
      for (const items of batchValue.seq) {
        const index = binarySearch(state.fwRulesList, items, 0, state.fwRulesList.length - 1)
        if (index > -1) {
          const rules = fwRulesList[index]
          fwRulesList[index] = _.assign(rules, { use: 0 })
        }
      }
      state.fwRulesList = Object.freeze(fwRulesList)
    } else {
      const fwRuleId = state.selectedPolicyData.fw_rule_id, fwGroupId = state.selectedPolicyData.fw_grp_id
      state.fwRulesList = Object.freeze(_.map(state.fwRulesList, (rules) => {
        if (rules.fw_grp_id === fwGroupId && !rules.is_group && rules.fw_rule_id === fwRuleId) {
          rules = parseBatchValue(rules, batchValue)
        }
        return rules
      }))
    }
  },
  // 방화벽 정책 복사, 코드 리펙토링 필요.... 절대적
  copyPolicy (state) {
    let selectData = []
    const copyFwRulesData = []
    const selectedPolicyData = state.selectedPolicyData
    if (state.multipleSelect) selectData = selectedPolicyData
    else selectData = [selectedPolicyData]
    _.forEach(selectData, (data) => {
      copyFwRulesData.push({ fw_rule_id: data.fw_rule_id })
    })
    state.copyFwRulesData = copyFwRulesData
  },
  // 방화벽 정책 붙여넣기
  pastePolicy (state, data) {
    const selectRule = state.selectedPolicyData
    const addIndex = _.findIndex(state.fwRulesList, {fw_rule_id: selectRule.fw_rule_id})
    const fwRulesList = _.cloneDeep(state.fwRulesList)
    fwRulesList.splice(addIndex, 0, data)
    state.fwRulesList = Object.freeze(fwRulesList)
    updateRuleSeq(state) // 정책 seq 업데이트
  },
  // 방화벽 정책 옵션 - 세션 제한 값 변경
  changeSessionLimit (state, value) {
    if (value) state.fwRulesData.fw_rule[0].fw_rule_sess_limit_type = 1
    else state.fwRulesData.fw_rule[0].fw_rule_sess_limit_type = 0
  },
  // 방화벽 정책 옵션 - 세션 제한 타입 변경
  limitTypeChange (state, value) { state.fwRulesData.fw_rule[0].fw_rule_sess_limit_type = value },
  // 방화벽 정책 상세 보기
  getFwDetailRules (state, data) { state.fwDetailRulesDataList = data },
  // 기본 그룹 지정
  setFwGroup (state, data) { state.fwRulesData.fw_grp_id = data },
  // 다중 선택 여부 설정
  setMultipleSelect (state, data) { state.multipleSelect = data },
  // context-menu: 객체 복사
  setCopyFwInObject (state, item) { state.copyFwInObject = item },
  // 정책 팝업 창에서 String User 객체 별 추가
  saveStringUserDataInFirewall (state, {stringUser, usrObjType}) {
    if (usrObjType === 8 || usrObjType === 9) {
      state.fwRulesData.user = [ { usr_obj_type: usrObjType, str_name: stringUser } ]
    }
    if (usrObjType === 7) {
      if (state.fwRulesData.user[0].usr_obj_id === 0 ||
        state.fwRulesData.user[0].usr_obj_type === 8 ||
        state.fwRulesData.user[0].usr_obj_type === 9) {
        state.fwRulesData.user = []
      }
      state.fwRulesData.user.push({ str_name: stringUser, usr_obj_type: usrObjType })
    }
    state.fwRulesData.bi_dir = 0
    state.selectedAddObjectData = void 0
  },
  // 정책에서 사용 중인 QoS 목록 설정
  setFwUsedQosList (state, result) { state.usedQoSDataList = Object.freeze(result) },
  // 정책에서 사용 중인 QoS 목록 초기화
  resetFwUsedQosList (state) { state.usedQoSDataList = [] },
  setDisablePamsControlRule (state, payload) { state.disablePamsControlRule = payload },
  setFwPage (state, payload) {
    const pageKeys = ['page_pos', 'page_cnt', 'page_max', 'total_cnt', 'disabled_cnt', 'enabled_cnt', 'expired_cnt']
    pageKeys.forEach(key => {
      if (typeof payload[key] !== 'undefined') state.fwPage[key] = payload[key]
    })
    state.fwPage.page_max = state.fwPage.page_max === 0 ? 1 : Math.ceil(state.fwPage.page_max / state.fwPage.page_cnt)
  },
  setClosedFwGroups (state, payload) {
    const grpsKeys = Object.keys(initClosedFwGroups())
    grpsKeys.forEach(key => {
      if (typeof payload[key] !== 'undefined') state.closedFwGrps[key] = payload[key]
    })
  },
  resetClosedFwGroups (state, closed = false) { state.closedFwGrps = initClosedFwGroups(closed) },
  setFwGroupList (state, payload) { state.fwGroupList = payload }
}
export const actions = {
  // 방화벽 IP Version 설정
  setIpVersion ({commit}, {version}) { commit('setIpVersion', version) },
  async applyAction () {
    const result = await this.$axios.$put(`${poApiPrefix}/fw-rule/apply`, null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelAction () {
    const result = await this.$axios.$put(`${poApiPrefix}/fw-rule/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  async applyActionV6 () {
    const result = await this.$axios.$put(`${poApiPrefix}/fw6-rule/apply`, null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelActionV6 () {
    const result = await this.$axios.$put(`${poApiPrefix}/fw6-rule/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  async addPolicy ({state, dispatch}, succflag) {
    const param = state.fwRulesData
    const sendParam = {}
    let policyName = param.fw_rule[0].fw_rule_uname
    if (policyName === undefined) policyName = ''
    else policyName = param.fw_rule[0].fw_rule_uname
    sendParam.fw_grp_id = param.fw_grp_id
    sendParam.fw_rule_action_type = param.fw_rule[0].fw_rule_action_type
    sendParam.fw_rule_bidir_yn = param.fw_rule[0].fw_rule_bidir_yn
    sendParam.fw_rule_desc = param.fw_rule[0].fw_rule_desc
    sendParam.fw_rule_id = param.fw_rule[0].fw_rule_id
    sendParam.fw_rule_log_yn = param.fw_rule[0].fw_rule_log_yn
    sendParam.fw_rule_tcp_flag_yn = param.fw_rule[0].fw_rule_tcp_flag_yn
    sendParam.fw_rule_uname = policyName
    sendParam.fw_rule_use_yn = param.fw_rule[0].fw_rule_use_yn
    sendParam.time_obj_id = param.fw_rule[0].time_obj_id
    sendParam.fw_rule_inhrit_yn = param.fw_rule[0].fw_rule_inhrit_yn
    sendParam.fw_rule_sess_limit_block_yn = param.fw_rule[0].fw_rule_sess_limit_block_yn
    sendParam.fw_rule_sess_limit_ip_num = param.fw_rule[0].fw_rule_sess_limit_ip_num
    sendParam.fw_rule_sess_limit_num = param.fw_rule[0].fw_rule_sess_limit_num
    sendParam.fw_rule_sess_limit_type = param.fw_rule[0].fw_rule_sess_limit_type
    if (Number(state.version) === 6) {
      sendParam.fw_rule_ext_header_set = {}
      if (param.fw_rule_ext_header_set.hop !== undefined) sendParam.fw_rule_ext_header_set.hop = param.fw_rule_ext_header_set.hop
      else sendParam.fw_rule_ext_header_set.hop = 0
      if (param.fw_rule_ext_header_set.routing !== undefined) sendParam.fw_rule_ext_header_set.routing = param.fw_rule_ext_header_set.routing
      else sendParam.fw_rule_ext_header_set.routing = 0
      if (param.fw_rule_ext_header_set.fragment !== undefined) sendParam.fw_rule_ext_header_set.fragment = param.fw_rule_ext_header_set.fragment
      else sendParam.fw_rule_ext_header_set.fragment = 0
      if (param.fw_rule_ext_header_set.dest !== undefined) sendParam.fw_rule_ext_header_set.dest = param.fw_rule_ext_header_set.dest
      else sendParam.fw_rule_ext_header_set.dest = 0
      if (param.fw_rule_ext_header_set.auth !== undefined) sendParam.fw_rule_ext_header_set.auth = param.fw_rule_ext_header_set.auth
      else sendParam.fw_rule_ext_header_set.auth = 0
      if (param.fw_rule_ext_header_set.esp !== undefined) sendParam.fw_rule_ext_header_set.esp = param.fw_rule_ext_header_set.esp
      else sendParam.fw_rule_ext_header_set.esp = 0
    }
    const data = await this.$axios.$post(`${poApiPrefix}/fw-rule`, sendParam, {loading: false, successAlert: succflag}) // TAMS
    return data
  },
  async deletePolicy ({state, dispatch}, {resultParam, loading, loadingShow, successAlert}) {
    const data = await this.$axios.$put(`${poApiPrefix}/fw-rule`, resultParam, {loading: loading, loadingShow: loadingShow, successAlert: successAlert})
    return data
  },
  async changeUseNy ({commit, state}, param) {
    try {
      const data = await this.$axios.$post(`${poApiPrefix}/fw-rule/multi`, param, {loading: false, successAlert: false})
      return data
    } catch (error) { return error }
  },
  async changeInhritNy ({commit, state}, param) {
    try {
      const data = await this.$axios.$put(`${poApiPrefix}/fw-rule/multi`, param, {loading: false, successAlert: false})
      return data
    } catch (error) { return error }
  },
  async addFwObject ({state, dispatch}, { appResult, item, objectType }) {
    let res = {}, url = ''
    const params = {}
    params.fw_rule_id = item.fw_rule_id
    if (objectType.indexOf('srv') !== -1) {
      url = `${poApiPrefix}/fw-rule/srv-obj`
      params.srv_obj_id_list = [ item.srv_obj_id ]
    } else if (objectType.indexOf('src') !== -1 || objectType.indexOf('dst') !== -1) {
      const addrObj = {
        fw_rule_addr_obj_type: objectType.indexOf('dst') !== -1 ? 2 : 1, // 방화벽 정책 주소 객체 유형 (1: 출발지, 2: 목적지)
        addr_obj_except_yn: 0,
        addr_obj_id: item.addr_obj_id
      }
      url = `${poApiPrefix}/fw-rule/addr-obj`
      params.addr_obj_list = [ addrObj ]
    } else if (objectType.indexOf('app') !== -1) {
      let objectList = []
      if (item.app_obj_type === 3) {
        objectList = pickAppData(appResult)
      } else {
        if (_.get(item, ['app_filter_obj_id'])) item.app_obj_id = item.app_filter_obj_id
        objectList = [ pickAppData(item) ]
      }
      params.app_obj_list = objectList
      url = `${poApiPrefix}/fw-rule/app/objects`
    }
    res = await this.$axios.$post(url, params, { loading: false, successAlert: false })
    return res
  },
  async addFwMultipleObjectData ({state}, {items, objectType}) {
    const resultParam = {}
    let result = void 0
    resultParam.fw_rule_id = state.fwRulesData.fw_rule[0].fw_rule_id
    if (objectType.indexOf('srv') !== -1) {
      resultParam.srv_obj_id_list = _.map(items, 'srv_obj_id')
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/srv-obj`, resultParam, {loading: false, successAlert: false})
    } else if (objectType.indexOf('src') !== -1 || objectType.indexOf('dst') !== -1) {
      items = _.map(items, row => ({
        addr_obj_id: row.addr_obj_id,
        addr_obj_except_yn: _.get(row, ['addr_obj_except_yn'], 0), // TAMS, 방화벽 정책 설정 팝업 "계속" 기능 사용 시 예외 여부 판단
        fw_rule_addr_obj_type: objectType.indexOf('dst') !== -1 ? 2 : 1
      }))
      resultParam.addr_obj_list = items
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/addr-obj`, resultParam, {loading: false, successAlert: false})
    } else if (objectType.indexOf('app') !== -1) {
      if (_.get(items, ['0', 'app_filter_obj_id'])) {
        items = _.map(items, o => {
          o.app_obj_id = o.app_filter_obj_id
          return o
        })
      }
      resultParam.app_obj_list = items
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/app/objects`, resultParam, {loading: false, successAlert: false})
    }
    return result
  },
  // 방화벽 정책 내 객체 삭제 (단일)
  async deleteFwObject ({state, dispatch}, { item, objectType, multiple = false, forceYn = 0 } = {}) {
    let res = void 0
    const fwRuleId = state.fwRulesData.fw_rule[0].fw_rule_id
    if (objectType.indexOf('srv') !== -1) {
      let url = ''
      if (multiple) {
        url = `${poApiPrefix}/fw-rule/srv-obj/multi`
        const params = { force_yn: forceYn, fw_rule_id: fwRuleId, srv_obj_id_list: _.map(item, 'srv_obj_id') }
        res = await this.$axios.$put(url, params, { loading: false, successAlert: false })
      } else {
        url = `${poApiPrefix}/fw-rule/srv-obj/${fwRuleId}/${item.srv_obj_id}`
        res = await this.$axios.$delete(url, { loading: false, successAlert: false })
      }
    } else if (objectType.indexOf('src') !== -1 || objectType.indexOf('dst') !== -1) {
      let url = '', params = {}
      const fwRuleAddrObjType = objectType === 'src' ? 1 : 2 // 방화벽 정책 주소 객체 유형 (1: 출발지, 2: 목적지)
      if (multiple) {
        url = `${poApiPrefix}/fw-rule/addr-obj/multi`
        params = {
          force_yn: forceYn,
          fw_rule_id: fwRuleId,
          fw_rule_addr_obj_type: fwRuleAddrObjType,
          addr_obj_id_list: _.map(item, 'addr_obj_id')
        }
        res = await this.$axios.$put(url, params, { loading: false, successAlert: false })
      } else {
        url = `${poApiPrefix}/fw-rule/addr-obj/${fwRuleId}/${item.addr_obj_id}/${fwRuleAddrObjType}/${forceYn}`
        res = await this.$axios.$delete(url, { loading: false, successAlert: false })
      }
    } else if (objectType.indexOf('app') !== -1) {
      const url = `${poApiPrefix}/fw-rule/app/objects/multi`
      let params = {}
      if (multiple) params = { fw_rule_id: fwRuleId, app_obj_id_list: _.map(item, 'app_obj_id') }
      else params = { fw_rule_id: fwRuleId, app_obj_id_list: [item.app_obj_id] }
      res = await this.$axios.$put(url, params, { loading: false, successAlert: false })
    }
    return res
  },
  async changeExceptObject ({state, dispatch}, param) {
    const result = await this.$axios.$put(`${poApiPrefix}/fw-rule/addr-obj`, param, {loading: false, successAlert: false})
    return result
  },
  async getFWObject ({state, commit, dispatch}, { item, objectType }) {
    let res = void 0, url = ''
    if (objectType.indexOf('srv') !== -1) {
      url = `${poApiPrefix}/fw-rule/srv-obj/${item.fw_rule_id}`
    } else if (objectType.indexOf('src') !== -1 || objectType.indexOf('dst') !== -1) {
      const fwRuleAddrObjType = objectType.indexOf('dst') !== -1 ? 2 : 1
      url = `${poApiPrefix}/fw-rule/addr-obj/${item.fw_rule_id}/${fwRuleAddrObjType}`
    } else if (objectType.indexOf('app') !== -1) {
      url = `${poApiPrefix}/fw-rule/${item.fw_rule_id}/app/objects`
    }
    res = await this.$axios.$get(url, { loading: false, successAlert: false })
    if (res.code === 'ok') commit('addFwObjectData', { item: res.result, objectType })
  },
  // 오브젝트 뷰에서 객체 별 추가
  async addFwObjectViewData ({state, commit, dispatch}, {appResult, item, multiSelect, selectCellData, selectKey, selectRowData}) {
    const fwRuleId = selectRowData.fw_rule_id
    const resultParam = {}
    let result = void 0
    resultParam.fw_rule_id = fwRuleId
    if (selectKey.indexOf('srv') !== -1) {
      resultParam.srv_obj_id_list = [ item.srv_obj_id ]
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/srv-obj`, resultParam, {loading: false, successAlert: false})
    } else if (selectKey.indexOf('src') !== -1 || selectKey.indexOf('dst') !== -1) {
      item = _.assign(item, {
        addr_obj_except_yn: 0,
        fw_rule_addr_obj_type: selectKey.indexOf('dst') !== -1 ? 2 : 1 // 1: 출발지, 2: 목적지
      })
      resultParam.addr_obj_list = [ item ]
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/addr-obj`, resultParam, {loading: false, successAlert: false})
    } else if (selectKey.indexOf('time') !== -1) {
      const timeObjId = item.time_obj_id
      result = await this.$axios.$put(`${poApiPrefix}/fw-rule/time/${fwRuleId}/${timeObjId}`, null, {loading: false, successAlert: false})
    } else if (selectKey.indexOf('app') !== -1) {
      let objectList = []
      if (item.app_obj_type === 3) objectList = pickAppData(appResult)
      else {
        if (_.get(item, ['app_filter_obj_id'])) item.app_obj_id = item.app_filter_obj_id
        objectList = [ pickAppData(item) ]
      }
      resultParam.app_obj_list = objectList
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/app/objects`, resultParam, {loading: false, successAlert: false})
    }
    return result
  },
  // 오브젝트 뷰에서 객체 별 일괄 추가
  async addFwMultipleObjectViewData ({state, commit, dispatch}, {item, multiSelect, selectCellData, selectKey, selectRowData}) {
    const fwRuleId = selectRowData.fw_rule_id
    const resultParam = {}
    let result = void 0
    resultParam.fw_rule_id = fwRuleId
    if (selectKey.indexOf('srv') !== -1) {
      resultParam.srv_obj_id_list = _.map(item, 'srv_obj_id')
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/srv-obj`, resultParam, {loading: false, successAlert: false})
    } else if (selectKey.indexOf('src') !== -1 || selectKey.indexOf('dst') !== -1) {
      item = _.map(item, row => ({
        addr_obj_id: row.addr_obj_id,
        addr_obj_except_yn: 0,
        fw_rule_addr_obj_type: selectKey.indexOf('dst') !== -1 ? 2 : 1 // 방화벽 정책 주소 객체 유형 (1: 출발지, 2: 목적지)
      }))
      resultParam.addr_obj_list = item
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/addr-obj`, resultParam, {loading: false, successAlert: false})
    } else if (selectKey.indexOf('time') !== -1) {
      const timeObjId = item.time_obj_id
      result = await this.$axios.$put(`${poApiPrefix}/fw-rule/time/${fwRuleId}/${timeObjId}`, null, {loading: false, successAlert: false})
    } else if (selectKey.indexOf('app') !== -1) {
      if (_.get(item, ['0', 'app_filter_obj_id'])) {
        item = _.map(item, o => {
          o.app_obj_id = o.app_filter_obj_id
          return o
        })
      }
      resultParam.app_obj_list = item
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/app/objects`, resultParam, {loading: false, successAlert: false})
    }
    return result
  },
  // 기본 그룹 지정
  setFwGroup ({state, commit, rootState}) {
    const groupList = rootState.cm.securityPolicy.firewall.firewallPolicySettings.groupMgmt.groupList
    let defaultGroupID = groupList[0].fw_grp_id
    if (state.selectedPolicyData) defaultGroupID = state.selectedPolicyData.fw_grp_id
    commit('setFwGroup', defaultGroupID)
  },
  // 방화벽 정책 목록 조회
  async getFwRulesList ({commit, rootState, state}, {deviceId, fwRuleId, pagePos, pageCnt, loading} = {}) {
    let res = { code: 'ok', result: {} }
    try {
      if (deviceId === undefined) {
        deviceId = state.treeInfo.id
        if (deviceId === 0) deviceId = 1
      }
      const ipVersion = (state.version === 4) ? 1 : 2 // version 4, 6
      const filterType = state.filterType
      const closedFwGrp = _.cloneDeep(state.closedFwGrps)
      const makeClosedGrpParams = (closedGrp) => {
        const grpKeys = Object.keys(closedGrp)
        return _.map(grpKeys, grp => { return { grp_name: grp, is_closed: closedFwGrp[grp] ? 1 : 0 } })
      }
      const params = {
        page_cnt: typeof pageCnt === 'undefined' ? state.fwPage.page_cnt : pageCnt,
        page_pos: typeof pagePos === 'undefined' ? state.fwPage.page_pos : pagePos,
        closed_grp: makeClosedGrpParams(closedFwGrp)
      }
      if (typeof fwRuleId !== 'undefined') params.fw_rule_id = fwRuleId
      res = await this.$axios.$post(`${poApiPrefix}/fw-rule/page/${deviceId}/${ipVersion}/${filterType}`, params, { successAlert: false, loading: typeof loading === 'undefined' ? true : loading })
      if (res.code === 'ok') {
        const { pageMaxCount, fwGroupList, selectGroupList, fwEachRule, fwRulesList } = resFwRulesList(res, closedFwGrp)
        commit('setFwPage', {
          page_cnt: res.result.page_cnt,
          page_pos: res.result.page_pos,
          page_max: pageMaxCount, // 접힘/펼침 갯수 반영
          total_cnt: res.result.total_cnt,
          enabled_cnt: res.result.enabled_cnt,
          disabled_cnt: res.result.disabled_cnt,
          expired_cnt: res.result.expired_cnt
        })
        commit('setFwGroupList', fwGroupList)
        commit('setClosedFwGroups', closedFwGrp)
        commit('setSelectGroupList', selectGroupList)
        commit('setFwEachRule', _.cloneDeep(fwEachRule))
        commit('getFwRulesList', fwRulesList)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 방화벽 정책 빈설정 추가
  async addBeanPolicy ({commit, state, dispatch}, param) {
    let res = { code: 'ok', result: {} }
    try {
      res = await this.$axios.$post(`${poApiPrefix}/fw-rule/${param.fwGrpId}/${param.version}/${param.fwRuleSeq}`, null, { loading: false, successAlert: false })
      return res
    } catch (error) {
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 방화벽 정책 순서 변경 (최상위, 최하위)
  async changeSeq ({commit, state, dispatch}, {selectedFwRuleId, groupId, fwRuleSeq}) {
    const items = { fw_rule_id_list: selectedFwRuleId }
    const data = await this.$axios.$put(`${poApiPrefix}/fw-rule/seq/${groupId}/${fwRuleSeq}`, items, {loading: false, successAlert: false})
    return data
  },
  // 방화벽 정책 붙여넣기
  async pasteObjectPolicy ({commit, dispatch, state}) {
    const promises = []
    const copyFwRulesData = state.copyFwRulesData
    const selectedItem = state.selectedPolicyData
    const fwGrpId = selectedItem.fw_grp_id
    const fwRuleSeq = selectedItem.fw_rule_seq
    for (let i = 0; i < copyFwRulesData.length; i++) {
      promises.push(
        new Promise((resolve) => {
          let fwRuleId = 0
          fwRuleId = copyFwRulesData[i].fw_rule_id
          this.$axios.$put(`${poApiPrefix}/fw-rule/copy/${fwRuleId}/${fwGrpId}/${fwRuleSeq}`, null, {loading: true, successAlert: false})
            .then((data) => { resolve(data) })
        })
      )
    }
    const result = await Promise.all(promises)
    return result
  },
  // 방화벽 정책 수정 - 사용 여부
  async updatePolicyUse ({commit, state, dispatch}, {use, ruleId}) {
    const {code, result} = await this.$axios.$put(`${poApiPrefix}/fw/${state.version}/rules/${ruleId}`, {use})
    if (code === 'ok') {
      commit('updateFwRules', result)
      commit('resetSelectedPolicyRules')
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },
  // 방화벽 정책 수정 - 사용 여부 일괄 설정(그룹 일괄 설정)
  async fwSetGroupBatch ({commit, state, dispatch}, {type, batchValue, groupId}) {
    const items = {
      fw_grp_id: null, // 그룹 전체는 그룹 id, 선택한 정책은 null
      fw_rule_id_list: [], // 그룹 전체는 null, 선택한 정책은 [1, 2, 3, 4]
      fw_rule_use_yn: null, // 사용 -> null: 일괄 설정 대상이 아닌 경우,  0 : OFF, 1 : ON
      fw_rule_log_yn: null, // 로그 -> null: 일괄 설정 대상이 아닌 경우,  0 : OFF, 1 : ON
      fw_rule_tcp_flag_yn: null, // tcp -> null: 일괄 설정 대상이 아닌 경우,  0 : OFF, 1 : ON
      fw_rule_bidir_yn: null // 양방향 -> null: 일괄 설정 대상이 아닌 경우,  0 : OFF, 1 : ON
    }
    if (batchValue.use === undefined) items.fw_rule_use_yn = null
    else items.fw_rule_use_yn = batchValue.use
    if (batchValue.tcp_flag === undefined) items.fw_rule_tcp_flag_yn = null
    else items.fw_rule_tcp_flag_yn = batchValue.tcp_flag
    if (batchValue.bi_dir === undefined) items.fw_rule_bidir_yn = null
    else items.fw_rule_bidir_yn = batchValue.bi_dir
    if (batchValue.log === undefined) items.fw_rule_log_yn = null
    else items.fw_rule_log_yn = batchValue.log

    if (type === 'all') {
      items.fw_grp_id = groupId
      items.fw_rule_id_list = null
    } else {
      items.fw_grp_id = null
      if (state.selectedPolicyData.fw_rule_id === undefined) {
        for (const key of state.selectedPolicyData) {
          items.fw_rule_id_list.push(key.fw_rule_id)
        }
      } else {
        items.fw_rule_id_list.push(state.selectedPolicyData.fw_rule_id)
      }
    }
    const result = await this.$axios.$put(`${poApiPrefix}/fw-rule/batch-config`, items)
    if (result.code === 'ok') commit('fwSetGroupBatch', {type, batchValue, groupId})
    return result
  },
  // 방화벽 정책 조회
  async getFwRules ({commit, state}, {fwRuleId}) {
    const fwRulesId = fwRuleId
    const filterType = state.filterType
    const {code, result} = await this.$axios.$get(`${poApiPrefix}/fw-rule/${fwRulesId}/${filterType}`)
    if (code === 'ok') {
      commit('getFwRules', result)
      commit('setFirewallTimeObjectData', result)
      return code
    } else { return result }
  },
  // 방화벽 정책 일괄 삭제
  async deleteBatchFwRules ({commit, dispatch, state}, {type, batchValue}) {
    const params = { items: _.map(state.selectedPolicyData, o => _.pick(o, ['fw_rule_id'])) }
    const {code, result} = await this.$axios.$delete(`${poApiPrefix}/fw/${state.version}/rules`, {data: params})
    if (code === 'ok') {
      commit('deleteBatchFwRules', params.items)
      commit('resetSelectedPolicyRules')
      if (type === 'editSearch') dispatch('securityPolicy/firewall/firewallPolicySettings/editPolicySearch/updateSearchData', {batchValue}, {root: true})
      if (type === 'applySearch') dispatch('securityPolicy/firewall/firewallPolicySettings/applyPolicySearch/updateSearchData', {batchValue}, {root: true})
      dispatch('common/common/setIsChanged', true, {root: true})
    } else if (code === 'pok' || code === 'nok') return result.errors
  },
  async excelDownloadOfDevice ({commit, rootState, state}, {isBatch = false} = {}) {
    let deviceId = state.treeInfo.id
    if (deviceId === 0) deviceId = 1
    const ipVersion = state.version === 4 ? 1 : 2
    let queryString = '?is_batch=0&is_split=0'
    if (isBatch) queryString = '?is_batch=1&is_split=1&split_count=2000'
    const url = `${poApiPrefix}/fw-rule/save/device/${deviceId}/${ipVersion}${queryString}`
    // STEP 1: 다운 시작 요청
    const {code, result} = await this.$axios.$get(url, {loading: false})
    if (code !== 'ok') return {code: 'error', result: result}
    const taskId = result.id
    // STEP2: 상태 조회
    let isPollingTask = true
    let filename = ''
    await sleep(1000)
    while (isPollingTask) {
      const pollingRes = await this.$axios.$get(`${poApiPrefix}/fw-rule/save/device/${deviceId}/tasks/${taskId}`, {loading: false})
      if (pollingRes.result.status === 'SUCCESS') {
        isPollingTask = false
        filename = pollingRes.result.filename
      } else if (pollingRes.result.status === 'FAIL') return {code: 'error', result: {msg: pollingRes.result.error}}
      else await sleep(3000)
    }
    // STEP3: 다운로드
    const {data, fileName} = await this.$axios.$file(`${poApiPrefix}/fw-rule/save/device/${deviceId}/tasks/${taskId}/save?filename=${filename}`, {responseType: 'blob', loading: false})
    pcDownloadFile(data, fileName)
  },
  // 엑셀 파일 다운로드
  async excelFileDownload ({state}, {taskId}) {
    const {data, fileName} = await this.$axios.$file(`${cmnApiPrefix}/async/tasks/${taskId}/save`, {responseType: 'blob'})
    pcDownloadFile(data, fileName)
  },
  // 방화벽 정책 적용
  async policyApply ({state, commit, dispatch}) {
    await this.$axios.$put(`${poApiPrefix}/command/fw-${state.version}-policies/apply`, void 0, { applyMsg: true })
    commit('resetSelectedPolicyRules')
    dispatch('common/common/setIsChanged', false, {root: true})
  },
  // 방화벽 정책 상세 보기
  async getFwDetailRules ({state, commit}, {deviceId}) {
    const ipVersion = state.version === 4 ? 1 : 2
    const {code, result} = await this.$axios.$get(`${poApiPrefix}/fw-rule/detail/rules/${deviceId}/${ipVersion}`)
    if (code === 'ok') commit('getFwDetailRules', result)
  },
  // 방화벽 임시 저장
  async saveTempStorage ({state, commit, rootState, dispatch}) {
    const policySetList = rootState.cm.securityPolicy.firewall.firewallPolicySettings.policySet.policySetList
    const usingSetId = _.find(policySetList, {use: 1}).fw_set_id
    const {code, result} = await this.$axios.$post(`${poApiPrefix}/fw/${state.version}/sets/${usingSetId}/tempsave`, void 0, { successAlert: false })
    if (code === 'ok') {
      commit('cm/securityPolicy/firewall/firewallPolicySettings/policySet/setTempStoragePolicySet', result, {root: true})
      dispatch('common/common/setIsChanged', false, {root: true})
    }
  },
  // 방화벽 정책 출발지 ↔ 목적지 교환
  async changePolicyAddress ({state}) {
    const selectedRuleId = { fw_rule_id_list: [] }
    if (state.multipleSelect) {
      for (const key of state.selectedPolicyData) { selectedRuleId.fw_rule_id_list.push(key.fw_rule_id) }
    } else { selectedRuleId.fw_rule_id_list.push(state.selectedPolicyData.fw_rule_id) }
    const result = await this.$axios.$put(`${poApiPrefix}/fw-rule/seq`, selectedRuleId, {loading: false, successAlert: false})
    return result
  },
  // 방화벽 정책  context-menu: 객체 삭제
  async deleteContextObject ({state, commit, dispatch}, {cellItem, rowItem, field}) {
    let result = null
    let srcDstType = void 0
    if (field === 'src_addr_obj') srcDstType = 1
    else if (field === 'dst_addr_obj') srcDstType = 2
    if (field === 'srv_obj') result = await this.$axios.$delete(`${poApiPrefix}/fw-rule/srv-obj/${rowItem.fw_rule_id}/${cellItem.srv_obj_id}`, { loading: false, successAlert: false })
    else if (['src_addr_obj', 'dst_addr_obj'].includes(field)) result = await this.$axios.$delete(`${poApiPrefix}/fw-rule/addr-obj/${rowItem.fw_rule_id}/${cellItem.addr_obj_id}/${srcDstType}/0`, { loading: false, successAlert: false })
    else if (field === 'time_obj') result = await this.$axios.$put(`${poApiPrefix}/fw-rule/time/${rowItem.fw_rule_id}/0`, null, {loading: false, successAlert: false})
    else if (field === 'fw_rule_desc') {
      const resultParam = {}
      const param = {}
      param.fw_rule_desc = ''
      param.fw_rule_id = rowItem.fw_rule_id
      resultParam.list = [param]
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/desc`, resultParam, {loading: false, successAlert: false})
    } else if (field === 'app_obj') {
      const url = `${poApiPrefix}/fw-rule/app/objects/multi`
      const params = {
        fw_rule_id: rowItem.fw_rule_id,
        app_obj_id_list: [ cellItem.app_type !== 3 ? cellItem.app_obj_id : cellItem.app_filter_obj_id ]
      }
      result = await this.$axios.$put(url, params, { loading: false, successAlert: false })
    } else if (field === 'security_profile') {
      const fwRuleId = rowItem.fw_rule_id
      const params = { fw_rule_prf_type: cellItem.type_id, fw_rule_prf_id: null }
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/profile/${fwRuleId}`, params, { loading: false, successAlert: false })
    }
    return result
  },
  async editContextDesc ({state}, {descData, fwRuleId}) {
    const resultParam = {}
    const param = {}
    param.fw_rule_desc = descData
    param.fw_rule_id = fwRuleId
    resultParam.list = [param]
    const result = await this.$axios.$post(`${poApiPrefix}/fw-rule/desc`, resultParam, {loading: false, successAlert: false})
    return result
  },
  // 방화벽 정책  context-menu: 객체 붙여넣기 gihwan
  async pasteFwInObject ({state, commit, dispatch}, {cellItem, rowItem, field}) {
    const copyObj = state.copyFwInObject
    let srcDstType = void 0, result = null
    const param = {}, resultParam = {}, ruleId = rowItem.fw_rule_id
    if (field === 'srv_obj') {
      const srvObjId = copyObj.srv_obj_id
      if (srvObjId === undefined) return
      param.fw_rule_id = ruleId
      param.srv_obj_id_list = [srvObjId]
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/srv-obj`, param, {loading: false, successAlert: false})
    } else if (field === 'src_addr_obj' || field === 'dst_addr_obj') {
      param.addr_obj_id = copyObj.addr_obj_id
      if (copyObj.addr_obj_id === undefined) return
      param.addr_obj_except_yn = copyObj.addr_obj_except_yn
      if (field === 'src_addr_obj') srcDstType = 1
      else if (field === 'dst_addr_obj') srcDstType = 2
      param.fw_rule_addr_obj_type = srcDstType
      resultParam.fw_rule_id = ruleId
      resultParam.addr_obj_list = [param]
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/addr-obj`, resultParam, {loading: false, successAlert: false})
    } else if (field === 'time_obj') {
      const timeObjId = copyObj.time_obj_id
      if (timeObjId === undefined) return
      result = await this.$axios.$put(`${poApiPrefix}/fw-rule/time/${ruleId}/${timeObjId}`, null, {loading: false, successAlert: false})
    } else if (field === 'fw_rule_desc') {
      param.fw_rule_desc = copyObj.cellItem
      param.fw_rule_id = ruleId
      resultParam.list = [param]
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/desc`, resultParam, {loading: false, successAlert: false})
    } else if (field === 'app_obj') {
      const appObj = {
        app_obj_id: state.copyFwInObject.app_type === 3 ? state.copyFwInObject.app_filter_obj_id : state.copyFwInObject.app_obj_id,
        app_type: state.copyFwInObject.app_type
      }
      const url = `${poApiPrefix}/fw-rule/app/objects`
      const params = { fw_rule_id: rowItem.fw_rule_id, app_obj_list: [ appObj ] }
      result = await this.$axios.$post(url, params, {loading: false, successAlert: false})
    } else if (field === 'security_profile') {
      const fwRuleId = rowItem.fw_rule_id
      const params = { fw_rule_prf_type: state.copyFwInObject.cellItem.type_id, fw_rule_prf_id: state.copyFwInObject.cellItem.key }
      result = await this.$axios.$post(`${poApiPrefix}/fw-rule/profile/${fwRuleId}`, params, { loading: false, successAlert: false })
    }
    return result
  },
  // 방화벽 정책  context-menu: 동작 변경
  async changeFwInAction ({state}, {rowItem, value}) {
    const param = {}
    const resultParamArr = []
    const fwRulesId = rowItem.fw_rule_id
    const paramArr = [fwRulesId, value]
    resultParamArr.push(paramArr)
    param.fw_rule_id_list = resultParamArr
    const result = await this.$axios.$post(`${poApiPrefix}/fw-rule/act`, param, {loading: false, successAlert: false})
    return result
  },
  // Log 옵션 변경 fw_rule_log_yn
  async changeFwLogOption ({state}, {rowItem}) {
    const fwRulesId = rowItem.fw_rule_id
    let logYn = rowItem.fw_rule_log_yn
    if (logYn === 1) logYn = 0
    else if (logYn === 0) logYn = 1
    const result = await this.$axios.$put(`${poApiPrefix}/fw-rule/log/${fwRulesId}/${logYn}`, null, {loading: false, successAlert: false})
    return result
  },
  // 양방향 옵션 변경 fw_rule_bidir_yn
  async changeFwBiDirOption ({state}, {rowItem}) {
    const fwRulesId = rowItem.fw_rule_id
    let bidirYn = rowItem.fw_rule_bidir_yn
    if (bidirYn === 1) bidirYn = 0
    else if (bidirYn === 0) bidirYn = 1
    const result = await this.$axios.$put(`${poApiPrefix}/fw-rule/bidir/${fwRulesId}/${bidirYn}`, null, {loading: false, successAlert: false})
    return result
  },
  // TCP Flag 옵션 변경 fw_rule_tcp_flag_yn
  async changeFwTcpOption ({state}, {rowItem}) {
    const fwRulesId = rowItem.fw_rule_id
    let tcpYn = rowItem.fw_rule_tcp_flag_yn
    if (tcpYn === 1) tcpYn = 0
    else if (tcpYn === 0) tcpYn = 1
    const result = await this.$axios.$put(`${poApiPrefix}/fw-rule/tcp-flag/${fwRulesId}/${tcpYn}`, null, {loading: false, successAlert: false})
    return result
  },
  // Session Limit 옵션 변경 fw_rule_sess_limit_block_yn
  async changeFwSessionOption ({state}, {rowItem, command}) { // command : useSession, setSession, noUseSession
    let sessionYn = void 0
    if (command === 'noUseSession') sessionYn = 0
    else sessionYn = rowItem.fw_rule_sess_limit_type
    const param = {}
    param.fw_rule_id = rowItem.fw_rule_id
    param.fw_rule_sess_limit_block_yn = rowItem.fw_rule_sess_limit_block_yn
    param.fw_rule_sess_limit_ip_num = rowItem.fw_rule_sess_limit_ip_num
    param.fw_rule_sess_limit_num = rowItem.fw_rule_sess_limit_num
    param.fw_rule_sess_limit_type = sessionYn
    const result = await this.$axios.$put(`${poApiPrefix}/fw-rule/sess-limit`, param, {loading: false, successAlert: false})
    return result
  },
  // 방화벽 정책  context-menu: 객체 자동 생성
  async saveFwInAutoCreateObject ({state, commit, dispatch}, {selectObj, rowItem, objId}) {
    const fwRuleId = rowItem.fw_rule_id
    const resultParam = {}
    const param = {}
    let objType = void 0
    if (selectObj === 'src_addr_obj') objType = 1
    else if (selectObj === 'dst_addr_obj') objType = 2
    param.addr_obj_except_yn = 0
    param.addr_obj_id = objId
    param.fw_rule_addr_obj_type = objType
    resultParam.fw_rule_id = fwRuleId
    resultParam.addr_obj_list = [param]
    const result = await this.$axios.$post(`${poApiPrefix}/fw-rule/addr-obj`, resultParam, {loading: false, successAlert: false})
    return result
  },
  // 방화벽 정책  context-menu: 시간 객체 자동 생성
  async saveFwInAutoCreateTimeObject ({state, commit, dispatch}, {ruleId}) {
    const timeData = state.fwRuleTimeData
    const result = await this.$axios.$put(`${poApiPrefix}/fw-rule/time/${ruleId}/${timeData.time_obj_id}`, null, { loading: false, successAlert: false })
    if (result.code === 'ok') commit('updateFwRules', result.result)
    return result
  },
  // 방화벽 정책 String User 추가
  async saveStringUserDataInFirewall ({state, commit, dispatch}, {stringUser, ruleId}) {
    const resultParam = { user: [ {name: stringUser, usr_obj_type: 7} ], bi_dir: 0 }
    const {code, result} = await this.$axios.$put(`${poApiPrefix}/fw/${state.version}/rules/${ruleId}`, resultParam)
    if (code === 'ok') {
      commit('updateFwRules', result)
      commit('resetSelectedPolicyRules')
      dispatch('common/common/setIsChanged', true, {root: true})
    }
  },
  // 정책에서 사용되는 객체 툴팁 데이터 조회
  async getObjectTooltipData ({state, commit, dispatch}, {rowItem, type}) {
    let url = void 0
    if (type === 'address') {
      let addrType = void 0
      if (rowItem.addr_obj_type === 4) addrType = 'addr-group'
      else addrType = 'addr'
      url = `${opApiPrefix}/${addrType}/objects/${rowItem.addr_obj_id}`
    }
    if (type === 'application') {
      if (rowItem.app_type === 1 || rowItem.app_type === undefined || rowItem.app_obj_type === 3) {
        url = `${poApiPrefix}/fw-rule/app/objects/${rowItem.app_obj_id}`
      }
      if (rowItem.app_type === 2) url = `${poApiPrefix}/fw-rule/app-group/objects/${rowItem.app_obj_id}`
      if (rowItem.app_type === 3) url = `${poApiPrefix}/fw-rule/app-filter/objects/${rowItem.app_filter_obj_id || rowItem.app_obj_id}`
    }
    if (type === 'service') {
      if (rowItem.srv_obj_type === 1) url = `${opApiPrefix}/srv/objects/${rowItem.srv_obj_id}` // 서비스 객체
      else if (rowItem.srv_obj_type === 2) url = `${opApiPrefix}/srv-group/objects/${rowItem.srv_obj_id}` // 서비스 그룹 객체
    }
    if (type === 'device') {
      if (rowItem.dvc_obj_type === 1) url = `${poApiPrefix}/device/objects/${rowItem.dvc_obj_id}`
      if (rowItem.dvc_obj_type === 2) url = `${poApiPrefix}/device-group/objects/${rowItem.dvc_grp_id}`
    }
    if (type === 'time') url = `${opApiPrefix}/time/objects/${rowItem.time_obj_id}`
    const {code, result} = await this.$axios.$get(url, { loading: false })
    if (code === 'ok') return result
  },
  // 방화벽 정책 QoS 프로파일 설정 목록 조회
  async getFwUsedQosList ({state, commit}, {deviceId, ruleId}) {
    const {code, result} = await this.$axios.$get(`${spApiPrefix}/qos/profiles/fw/${deviceId}/${ruleId}`)
    if (code === 'ok') commit('setFwUsedQosList', _.castArray(result))
    return {code, result}
  }
}
export const getters = {}
export const strict = false
